import {
  SHOW_HUD,
  HIDE_HUD,
  REGISTER_HUD_REF,
  DECK_SET_DEVICE_ROLE
} from 'actions/deckActions';
import { LOGOUT } from 'actions/authActions';

const initialState = {
  displayHUD: false,
  deviceRole: localStorage.getItem('deviceRole')
};

export default function deck (state = initialState, action) {
  switch (action.type) {
  case SHOW_HUD:
    return { ...state,
      displayHUD: true
    };
  case HIDE_HUD:
    return { ...state,
      displayHUD: false
    };
  case REGISTER_HUD_REF:
    const refs = state.refs || {};
    refs[action.name] = action.ref;
    return { ...state, refs };
  case DECK_SET_DEVICE_ROLE:
    const { role } = action;
    return { ...state,
      deviceRole: role
    };
  case LOGOUT:
    return { ...initialState };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/deckReducer.js